import styled from 'styled-components'
import media from 'styled-media-query'
import {
  prop,
  palette,
  withProp,
  switchProp,
  theme,
  ifProp,
} from 'styled-tools'

import {
  getWidth,
  getHeight,
  buttonThemePrimary,
  buttonThemeSecondary,
  buttonThemeGhost,
  buttonThemeText,
  buttonThemeRed,
  buttonThemeGreen,
} from '../HTMLButton/styled'

export const WrapperLink = styled.a`
  ${ifProp({ alignment: 'center' }, 'text-align: center;')};
`

export const CTAButton = styled.button`
  border-radius: ${theme('radius.base')};
  font-size: 14px;
  font-weight: ${theme('typography.weight.bold')};
  padding: 0 20px;
  color: ${palette('white')};
  border: 1px solid transparent;
  transition: background-color ${palette('speed.base')} ease-in-out;
  width: 100%;

  ${ifProp('forceFullWidth', 'width: 100% !important;')};

  ${withProp('size', getHeight)};

  ${switchProp(
    prop('kind'),
    {
      primary: buttonThemePrimary,
      secondary: buttonThemeSecondary,
      ghost: buttonThemeGhost,
      text: buttonThemeText,
      green: buttonThemeGreen,
      red: buttonThemeRed,
    },
    buttonThemePrimary
  )}

  ${withProp('size', size => getWidth(size))};
  ${media.greaterThan('small')`
    width: initial;
  `}
`



// WEBPACK FOOTER //
// ./includes/yoco-website-cms-gatsby/src/components/atoms/Button/styled.js